import { AccountLedgerEvents } from '../../../../containers/Trading/Markets/AccountLedgerEvents/AccountLedgerEvents';
import type { AccountLedgerEventsDetailsPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../types';

export function AccountLedgerEventsDetailsPanel({
  api,
  params,
}: LayoutPanelProps<AccountLedgerEventsDetailsPanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="account-ledger-events-panel">
      <AccountLedgerEvents
        asset={params.asset}
        account={params.account}
        accountType={params.accountType}
        key={api.id}
      />
    </Panel>
  );
}
